module.exports = __webpack_public_path__ + "static/1125619200.6d2e120d.jpg";